// extracted by mini-css-extract-plugin
module.exports =  {"adminQueueAlert":"Ecnycy6r","left":"cyHmAbyK","badgeContainer":"sy4nKyF2","error":"E1vV8tAE","badgeIcon":"cALtDcvM","tip":"vngQQ7b4","paused":"gmb74FVM","warning":"mulaN1Ua"};